/**
 * Formats a phone number by adding '+' prefix if missing
 * @param phoneNumber - The phone number to format
 * @returns Formatted phone number with '+' prefix
 */
export function formatPhoneNumber(phoneNumber: string | undefined): string {
  if (!phoneNumber) return '';

  // Remove any whitespace
  const cleaned = phoneNumber.trim();

  // If already has +, return as is
  if (cleaned.startsWith('+')) {
    return cleaned;
  }

  // Add + prefix
  return `+${cleaned}`;
}
